import React, { createContext, useContext, useEffect, useState } from "react";
import { dict, LANGUAGES } from "@/i18n/dict";

const I18nCtx = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("rds:lang") || "en");
  useEffect(() => { localStorage.setItem("rds:lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = dict[lang] || dict.en;
  return <I18nCtx.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>{children}</I18nCtx.Provider>;
};

export const useI18n = () => {
  const v = useContext(I18nCtx);
  if (!v) throw new Error("useI18n must be inside I18nProvider");
  return v;
};
